"use client";
import React, { useState } from "react";
import MainNav from "./main-nav";
import { NavigationItem } from "./types";

import { graphql, useStaticQuery } from "gatsby";
import useGetNav from "./hooks/use-get-nav";

type page = { id: string; data: { url: string } };

export type FaqNavbarProps = {};
export const FAQNavbar: React.FC<FaqNavbarProps> = ({}) => {
  const data = useStaticQuery(faqNavBarQuery).allBuilderModels;
  const navigationItems: NavigationItem[] =
    data.oneNavigation.data.navigationItems;
  const pages: page[] = data.page;
  const navItems: NavigationItem[] | undefined = useGetNav({
    location: "FAQ",
  })?.navItems;
  //console.log("nav items", navigationItems);
  //we will loop every nav item and submenu and see if a page has been referenced and if it has we will lookup the correct url
  const mappedNavItems = navigationItems.map((nav) => {
    let navItem: NavigationItem = nav;
    if (nav.page) {
      //lookk up via ID from the pages list
      const linkedPage = pages.find((p) => p.id === nav.page?.id);
      navItem = { ...nav, url: linkedPage?.data.url };
    }

    //now basically do the same for sub navigation, and i'm going to be lazy and copy and paste code
    if (navItem.subNavigation && navItem.subNavigation.listItems.length > 0) {
      navItem.subNavigation.listItems.map((subNav) => {
        if (subNav.page) {
          const linkedPage = pages.find((p) => p.id === subNav.page?.id);
          subNav.url = linkedPage?.data.url || "/";
        }
      });
    } else {
      navItem.subNavigation = undefined;
    }
    return navItem;
  });

  //console.log("mapped items", mappedNavItems);
  const [closed, setClosed] = useState(true);

  return (
    <div className="flex flex-wrap sm:justify-start sm:flex-nowrap  w-full text-sm py-4">
      <div
        className="max-w-[85rem] w-full mx-auto px-4 flex items-center justify-between"
        aria-label="Global"
      >
        {navItems && <MainNav nav={{ navigationItems: navItems }} />}
      </div>
    </div>
  );
};

export default FAQNavbar;

export const faqNavBarQuery = graphql`
  query FaqNavigation {
    allBuilderModels {
      oneNavigation(
        query: { data: { location: "FAQ" } }
        options: { includeRefs: true, cacheBust: true }
      ) {
        data {
          navigationItems
          location
        }
      }
      page {
        data {
          url
        }
        id
      }
    }
  }
`;
